import { useNotificationContext } from '@providers/NotificationProvider';

export const useStyles = (color: string, primary = false) => {
  const { notificationTheme: appTheme } = useNotificationContext();

  return {
    root: {
      fontSize: 14,
      padding: '5px 12px',
      borderRadius: '99px',
      fontWeight: 500,
      lineHeight: 1.4,
      textTransform: 'none',
      color: color,
      border: `1px solid ${primary ? appTheme.mainColor : color}`,
      backgroundColor: primary ? appTheme.mainColor : 'transparent',
      '&:hover': {
        borderColor: primary ? appTheme.mainColor : color,
        backgroundColor: primary ? appTheme.mainColor : 'transparent',
      },
    },
  };
};
